export default {
  header: '主页',
  dashboard: {
    header: '仪表板',
    startDate: '开始日期',
    endDate: '结束日期',
    search: '搜寻',
    static: '统计',
    policyType: '保单类别',
    chart: {
      casesByProvider: '单量/保险公司',
      commissionByProvider: '佣金/保险公司',
      commissionByAgent: '佣金/顾问',
      fycByAgent: '顾问首年佣金（首10名）',
      casesTrend: '单量趋势',
      fycTrend: '首年佣金趋势',
      unit: {
        casesByProvider: '交单数量',
        commissionByProvider: '佣金额度',
        commissionByAgent: '佣金额度',
        fycByAgent: '首年佣金额度',
        casesTrend: '交单数量',
        fycTrend: '首年佣金额度'
      }
    }
  },
  message: {
    headers: {
      message: '信息',
      bulletin: '公告',
      birthday: '生日',
      renewal: '续保'
    },
    bulletin: {
      attachment: '附件',
      edit: '编辑附件'
    },
    word: '字',
    createBulletin: '新增公告',
    subject: '主题',
    bulletinSubject: '公告主题',
    bulletinContent: '公告内容',
    category: '分类'
  }
}


// WEBPACK FOOTER //
// ./src/Homepage/langs/zh_cn/index.js